import {
  AlertColor,
  GlobalStateSlot,
  //alpha,
  lighten,
} from '@mui/material';
import {
  blue,
  blueGrey,
  cyan,
  deepOrange,
  deepPurple,
  indigo,
  lightGreen,
  orange,
  pink,
  purple,
  red,
  teal,
} from '@mui/material/colors';

import { AssignmentType } from '../models';
import { GradientConfig, GradientVariant, MuiColor } from './types';

export const MUI_STATE_CLASSES = {
  checked: 'Mui-checked',
  focused: 'Mui-focused',
  focusVisible: 'Mui-focusVisible',
  selected: 'Mui-selected',
  disabled: 'Mui-disabled',
  error: 'Mui-error',
} as const satisfies Partial<Record<GlobalStateSlot, string>>;

export const HTML_EDITOR_CLASSES = {
  content: 'ProseMirror',
  contentFocused: 'ProseMirror-focused',
  trailingBreak: 'ProseMirror-trailingBreak',
} as const;

export const ALERT_COLORS: AlertColor[] = ['success', 'error', 'warning', 'info'];

export const COLOR_OPTIONS: MuiColor[] = ['primary', 'secondary', ...ALERT_COLORS];

export const CONTRAST_THRESHOLD = 4.5;

export const GRADIENT_COLORS: Record<
  GradientVariant | AssignmentType,
  Omit<GradientConfig, 'angle'>
> = Object.freeze({
  // Variant gradients
  blue: { color1: blue[600], color2: blue[900] },
  cyan: { color1: cyan[900], color2: indigo[800] },
  green: { color1: lightGreen[600], color2: lightGreen[900] },
  grey: { color1: blueGrey[500], color2: blueGrey[800] },
  indigo: { color1: indigo[700], color2: deepPurple[400] },
  light: { color1: lighten(teal[400], 0.8), color2: lighten(purple[800], 0.8) },
  orange: { color1: orange[800], color2: orange[900] },
  pink: { color1: pink[700], color2: pink[900] },
  purple: { color1: purple[400], color2: deepPurple[800] },
  red: { color1: red[400], color2: red[800] },
  teal: { color1: cyan[700], color2: cyan[900] },
  //amber: { color2: alpha(purple[800], 0.2), color1: alpha(teal[400], 0.2) },

  // Assignment type gradients
  [AssignmentType.READING_COMPREHENSION]: { color1: blue[600], color2: blue[900] },
  [AssignmentType.QUIZ]: { color1: deepOrange[500], color2: deepOrange[900] },
  [AssignmentType.STUDY_GUIDE]: { color1: cyan[700], color2: cyan[900] },
  [AssignmentType.TEST]: { color1: '#3f51b5', color2: '#3f51b5' },
  [AssignmentType.DISCUSSION]: { color1: purple[600], color2: deepPurple[800] },
  [AssignmentType.TUTOR]: { color1: teal[700], color2: teal[900] },
});

export const HIGHLIGHT_COLOR = 'rgba(255, 243, 100, 0.95)';
